const messages = {
  es: {
    translations: {

      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Inicia sesión!.",
          fail: "Error al crear el usuario. Comprueba los datos introducidos.",
          userCreationDisabled: "El registro de nuevos usuarios está deshabilitado.",
          verificationError: "Error al verificar permisos de registro.",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          company: "Nombre de la Organización",
          phone: "Whatsapp (Código de área + N?MERO)",
          plan: "Plan",
          planDetails: {
            attendants: "Agentes",
            whatsapp: "WhatsApp",
            queues: "Colas",
            currency: "?",
          },
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!"
        }
      },
      validation: {
        tooShort: "¡Muy corto!",
        tooLong: "¡Muy largo!",
        required: "Obligatorio",
        invalidEmail: "Correo electrónico inválido",
        emailPlaceholder: "Dirección de correo electrónico",
        phonePlaceholder: "Ej: +34 612 345 678 (opcional)",
      },
      login: {
        title: "Iniciar Sesión",
        logoAlt: "Logo",
        emailLabel: "Correo electrónico",
        passwordLabel: "Contraseña",
        rememberMe: "Recordarme",
        loginButton: "Iniciar Sesión",
        signupButton: "Regístrate",
        noAccount: "¿No tienes una cuenta?",
        forgotPassword: "¿Olvidaste la contraseña?",
        whatsappLabel: "Chatea con nosotros en WhatsApp",
        whatsappTitle: "Chatea con nosotros en WhatsApp",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
          button: "Acceder"
        },
        buttons: {
          submit: "Iniciar Sesión",
          register: "¿No tienes una cuenta? ¡Regístrate!"
        }
      },
      companies: {
        title: "Empresas",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!"
        }
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión realizado con éxito!"
        },
        dueDate: {
          expiration: "Tu suscripción vence en",
          days: "¡días!",
          day: "¡día!",
          expirationToday: "¡Tu suscripción vence hoy!"
        },
        token: "Token"
      },
      forgotPassword: {
        title: "Restablecer Contraseña",
        form: {
          emailLabel: "Ingresa tu correo electrónico",
          submitButton: "Enviar Enlace de Restablecimiento",
          backToLogin: "Volver al Inicio de Sesión",
        },
        loading: {
          sending: "Enviando...",
          sent: "¡Enviado!",
        },
        toasts: {
          success: "Enlace de restablecimiento de contraseña enviado con éxito",
        },
      },
      resetPassword: {
        title: "Restablecer Contraseña",
        form: {
          newPassword: "Nueva Contraseña",
          confirmPassword: "Confirmar Contraseña",
        },
        buttons: {
          submit: "Restablecer Contraseña",
          submitting: "Restableciendo...",
          submitted: "¡Restablecido!",
          backToLogin: "Volver al Inicio de Sesión",
        },
        errors: {
          passwordMismatch: "Las contraseñas no coinciden",
          passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
          invalidToken: "El token de restablecimiento está ausente o es inválido. Por favor, solicita un nuevo enlace de restablecimiento.",
          resetError: "Error al restablecer la contraseña. Inténtalo de nuevo.",
        },
        toasts: {
          success: "Contraseña restablecida con éxito",
          passwordMismatch: "Las contraseñas no coinciden",
          passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        },
      },
      financeiro: {
        title: "Facturas",
        table: {
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          value: "Valor",
          dueDate: "Vencimiento",
          status: "Estado",
          action: "Acción"
        },
        tooltips: {
          details: "Detalles de la factura",
          users: "Número de usuarios",
          connections: "Número de conexiones",
          queues: "Número de colas",
          value: "Valor de la factura",
          dueDate: "Fecha de vencimiento"
        },
        status: {
          paid: "Pagado",
          overdue: "Vencido",
          open: "Abierto",
          yes: "Sí",
          no: "No",
          overdueFor: "Vencido hace {{days}} días",
          dueToday: "Vence hoy",
          dueIn: "Vence en {{days}} días"
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGADO",
          payNow: "PAGAR AHORA"
        },
        checkout: {
          title: "¡Falta poco!",
          steps: {
            data: "Datos",
            customize: "Personalizar",
            review: "Revisar"
          },
          messages: {
            notFound: "No encontrado",
            paymentNotice: "¡Después de realizar el pago, actualiza la página!",
            subscriptionSuccess: "¡Suscripción realizada con éxito! Esperando el procesamiento del pago"
          },
          buttons: {
            back: "VOLVER",
            pay: "PAGAR",
            next: "SIGUIENTE"
          },
          pricing: {
            users: "Usuarios",
            connection: "Conexión",
            queues: "Colas",
            select: "SELECCIONAR",
            perMonth: "/mes"
          },
          review: {
            title: "Resumen de suscripción"
          },
          success: {
            total: "TOTAL",
            copied: "Copiado",
            copyQr: "Copiar código QR",
            finalizeMessage: "Para finalizar, simplemente realiza el pago escaneando o pegando el código Pix de arriba :)",
            licenseRenewed: "Tu licencia ha sido renovada hasta"
          },
          planDetails: {
            title: "Detalles del plan",
            billing: "Facturación: Mensual"
          },
          paymentInfo: {
            title: "Información de pago",
            email: "Email:",
            name: "Nombre:",
            document: "CPF/CNPJ:",
            total: "Total:"
          }
        }
      },
      dashboard: {
        title: "Panel de Control",
        buttons: {
          filter: "Filtrar"
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Agentes",
          performance: "Rendimiento"
        },
        charts: {
          performance: "Gráficos",
          userPerformance: "Gráfico de Usuarios",
          hourlyServices: "Atendimientos por hora",
          ticketsLabel: "Tickets",
          score: "Puntuación",
          perDay: {
            title: "Atendimientos hoy: "
          },
          errorFetchingTickets: "Error al buscar información de los tickets",
          noDataAvailable: "No hay datos disponibles para el período seleccionado.",
        },
        cards: {
          inAttendance: "En Atención",
          waiting: "En Espera",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "T.M. de Atención",
          averageWaitingTime: "T.M. de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos"
        },
        users: {
          name: "Nombre",
          numberAppointments: "Cantidad de Atendimientos",
          statusNow: "Actual",
          totalCallsUser: "Total de atendimientos por usuario",
          totalAttendances: "Total de atendimientos",
          totalLabel: "Total de atendimientos: {{count}}",
          queues: "Colas",
          defaultQueue: "Conexión Predeterminada",
          workingHours: "Horario Laboral",
          startWork: "Inicio de Trabajo",
          endWork: "Fin de Trabajo",
          farewellMessage: "Mensaje de Despedida",
          theme: "Tema Predeterminado",
          menu: "Menú Predeterminado",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final"
        },
        licence: {
          available: "Disponible hasta"
        },
        assessments: {
          totalCalls: "Total de Atendimientos",
          callsWaitRating: "Atendimientos esperando evaluación",
          callsWithoutRating: "Atendimientos sin evaluación",
          ratedCalls: "Atendimientos evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntuación",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detractores",
          generalScore: "Puntuación NPS General",
        },
        status: {
          online: "Conectado",
          offline: "Desconectado",
        },
        filters: {
          title: "Filtros",
          initialDate: "Inicial",
          finalDate: "Final",
          filterButton: "Filtrar",
        },
        errors: {
          loadData: "No fue posible cargar los datos del dashboard.",
          exportExcel: "Error al exportar a Excel.",
        },
        export: {
          sheetName: "ReporteDeAgentes",
          fileName: "reporte-de-agentes.xlsx",
        },
        nps: {
          overallScore: "Puntuación NPS General",
        },
      },
      reports: {
        title: "Informe de Encuestas Realizadas",
        operator: "Operador",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Informes",
        calls: "Atendimientos",
        search: "Encuestas",
        durationCalls: "Duración de los Atendimientos",
        grupoSessions: "Atendimientos en Grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generando informe comprimido, por favor espere.",
          errorToast: "Error al generar el informe",
          back: "Volver",
          groupServiceReport: "Informe de Atendimientos en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha de ?ltima Actualización",
          agent: "Quién Atendió",
          agentClosed: "Quién Cerró",
          waitingAssistance: "Esperando Atención",
          process: "En Atención"
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidad",
          percentage: "porcentaje",
          title: "Informe de Encuestas Realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva"
        },
        ticketDurationDetail: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Duración del Atendimiento",
          startService: "Inicio del Atendimiento",
          lastUpdated: "?ltima Actualización",
          lastAgent: "?ltimo Agente",
          durationFinished: "Duración después de finalizado"
        },
        ticketDuration: {
          title: "Informe de Duración de los Atendimientos",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones"
        },
        ticketReports: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Atendimientos"
        },
        pdf: {
          title: "Relación de Atendimientos Realizados",
          exportTitle: "Relación de Atendimientos en Grupos Realizados"
        },
        form: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        excel: {
          connection: "Conexión",
          contact: "Contacto",
          user: "Usuario",
          queue: "Cola",
          status: "Estado",
          lastMessage: "?ltimo Mensaje",
          dateOpen: "FechaApertura",
          timeOpen: "HoraApertura",
          dateClose: "FechaCierre",
          timeClose: "HoraCierre",
          supportTime: "TiempoDeAtención",
          nps: "nps",
          fileName: "informe-de-atenciones.xlsx",
          sheetName: "InformeDeAtenciones",
        },
        tooltips: {
          ticketLogs: "Logs del Ticket",
          accessTicket: "Acceder al Ticket",
          exportExcel: "Exportar a Excel",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        save: "Guardar",
        task: "Tareas"
      },
      contactImportWpModal: {
        modalTitle: "Exportar / Importar Contactos",
        title: "Exportar Contactos para el Excel",
        buttons: {
          downloadModel: "Descargar modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar Contactos"
        },
        form: {
          connection: "Conexión de WhatsApp",
          connectionPlaceholder: "Seleccionar conexión...",
          importType: "Tipo de importación",
          importAll: "Importar todos los contactos",
          importSelected: "Importar contactos seleccionados",
          overwriteExisting: "Sobrescribir contactos existentes"
        },
        validation: {
          connectionRequired: "Debes seleccionar una conexión",
          noContactsFound: "No se encontraron contactos para importar"
        },
        progress: {
          importing: "Importando contactos...",
          imported: "Contactos importados: {count}",
          duplicated: "Contactos duplicados: {count}",
          failed: "Contactos fallados: {count}"
        },
        importComplete: "Importación completada con éxito",
        importInProgress: "Importación en progreso {current} de {total} - no salga de esta pantalla hasta completar la importación",
        sheetName: "Contactos",
        columns: {
          name: "Nombre",
          number: "Número",
          email: "E-mail",
          tags: "Etiquetas",
          followUp: "Seguimiento",
          productName: "Producto (Nombre)",
          productStatus: "Producto (Estado)",
        },
        sampleContact: {
          name: "Juan",
          number: "5491112345678",
          email: "juan@email.com",
          tags: "cliente, vip",
          followUp: "",
          productName: "Curso Marketing",
          productStatus: "completado",
        },
      },
      tagsContainer: {
        tagTooShort: "¡Etiqueta muy corta!",
        title: "Etiquetas del Contacto",
        placeholder: "Agregar etiqueta...",
        add: "Agregar",
        remove: "Eliminar",
        noTags: "Sin etiquetas asignadas",
        createNew: "Crear nueva etiqueta",
        searchPlaceholder: "Buscar etiquetas...",
        buttons: {
          save: "Guardar Etiquetas",
          cancel: "Cancelar",
          clear: "Limpiar Todo"
        },
        validation: {
          tagRequired: "El nombre de la etiqueta es obligatorio",
          tagExists: "Esta etiqueta ya existe",
          maxTags: "Máximo {max} etiquetas permitidas"
        }
      },
      allConnections: {
        errors: {
          loadCompanies: "No fue posible cargar la lista de registros",
          unknownChannel: "error"
        },
        subtitle: "Conecte sus canales de atención para recibir mensajes e iniciar conversaciones con sus clientes.",
        channels: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram"
        },
        table: {
          client: "Cliente",
          connectedConnections: "Conexiones Conectadas",
          disconnectedConnections: "Conexiones Desconectadas",
          totalConnections: "Total de Conexiones",
          total: "Total"
        }
      },
      companyWhatsapps: {
        title: "Conexiones de: {{companyName}}",
        table: {
          channel: "Canal"
        }
      },
      channels: {
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram"
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espera... ¡Tus conexiones se reiniciarán!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar Soporte",
        toasts: {
          deleted: "¡Conexión eliminada con éxito!",
          closedimported: "Estamos cerrando los tickets importados, por favor espere unos instantes"
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage: "Si confirmas, todos los tickets importados serán cerrados",
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Estás seguro? Deberás leer el código QR de nuevo."
        },
        buttons: {
          add: "Agregar Conexión",
          disconnect: "Desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "VER QR",
          newQr: "Generar QR nuevo",
          closedImported: "Cerrar todos los tickets importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes de WhatsApp",
          newQr: "Generar QR nuevo",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando"
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje"
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrate de que tu celular esté conectado a internet y intenta de nuevo, o solicita un nuevo Código QR"
          },
          qrcode: {
            title: "Esperando lectura del Código QR",
            content: "Haga clic en 'VER QR' y escanee el codigo con su celular para iniciar la sesion"
          },
          connected: {
            title: "¡Conexión establecida!"
          },
          timeout: {
            title: "La conexión con el celular fue perdida",
            content: "Asegúrate de que tu celular esté conectado a internet y el WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo Código QR"
          }
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "?ltima actualización",
          "default": "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          channel: "Canal"
        },
        iconChannel: {
          error: "Error"
        },
        facebook: {
          success: "Página conectada con éxito!",
        },
      },
      facebookModal: {
        title: "Conectar {{channel}}",
        description: "Siga los pasos a continuación para conectar {{channel}} al sistema de atención.",
        steps: {
          step1: {
            title: "Tener una App configurada en Meta for Developers",
            description: "Necesita tener una aplicación creada en Meta for Developers con los productos Messenger e Instagram configurados.",
          },
          step2: {
            title: "Tener una Página de Facebook",
            description: "Necesita ser administrador de una Página de Facebook. Messenger se conectará a esta página.",
          },
          step3instagram: {
            title: "Cuenta Instagram Business vinculada a la Página",
            description: "Para recibir mensajes de Instagram, su cuenta de Instagram debe ser del tipo Business o Profesional y estar vinculada a su Página de Facebook.",
          },
          stepConnect: {
            title: "Autorizar la conexión",
            description: "Haga clic en el botón de abajo para iniciar sesión con su cuenta de Facebook y autorizar {{channel}} para recibir y enviar mensajes a través del sistema.",
          },
        },
        permissions: {
          title: "Permisos solicitados:",
          sendReceive: "Enviar y recibir mensajes a través de la página",
          pagesList: "Listar sus páginas de Facebook",
          managePages: "Administrar metadata de las páginas",
          instagramMessages: "Enviar y recibir mensajes de Instagram Direct",
        },
        warning: {
          title: "Importante:",
          facebook: "Después de la autorización, todas las páginas vinculadas a su cuenta se conectarán automáticamente.",
          instagram: "Su cuenta de Instagram debe ser Business/Profesional y estar vinculada a una Página de Facebook. Después de la autorización, Instagram se conectará automáticamente.",
        },
        buttons: {
          cancel: "Cancelar",
          connect: "Conectar {{channel}}",
          connecting: "Conectando...",
        },
        errors: {
          noAppIdTitle: "Configuración pendiente!",
          noAppId: "Para conectar Facebook/Instagram es necesario configurar el App ID de Meta. Acceda a Meta for Developers, cree un App y configure la variable REACT_APP_FACEBOOK_APP_ID en el sistema.",
        },
        success: {
          facebook: "Facebook Messenger conectado con éxito!",
          instagram: "Instagram Direct conectado con éxito!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimiento Existente"
        },
        form: {
          message: "Este contacto ya está en atendimiento:",
          user: "Agente",
          queue: "Cola",
          messageWait: "Este contacto ya está esperando atendimiento. ¡Ve en la pestaña Esperando!",
          ticketId: "ID del Ticket",
          status: "Estado",
          createdAt: "Creado en",
          updatedAt: "Actualizado en"
        },
        buttons: {
          goToTicket: "Ir al Ticket",
          close: "Cerrar",
          transferTicket: "Transferir Ticket"
        },
        status: {
          open: "Abierto",
          pending: "Pendiente",
          closed: "Cerrado"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Registros"
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Cola definida.",
          open: " inició el atendimiento.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "devolvió la cola.",
          closed: "cerró el ticket",
          reopen: "reabrió el ticket",
          redirect: "- redirigido"
        },
        close: "Cerrar",
      },
      statusFilter: {
        title: "Filtro por Estado",
        groups: "Grupos",
      },
      whatsappModal: {
        title: {
          add: "Agregar Conexión",
          edit: "Editar Conexión"
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          schedules: "Horario de atención",
          chatbot: "Chatbot",
          defaultFlow: "Flujo por Defecto"
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del dispositivo",
          importOldMessages: "Fecha de inicio de la importación",
          importRecentMessages: "Fecha de finalización de la importación",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Cola",
          queueRedirectionDesc: "Selecciona una cola para que los contactos que no tienen cola sean redirigidos",
          "default": "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la cola",
          importAlert: "ATENCI?N: Al guardar, tu conexión se cerrará, será necesario leer de nuevo el Código QR para importar los mensajes",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Crear nuevo ticket en x minutos",
          maxUseBotQueues: "Enviar bot x veces",
          timeUseBotQueues: "Enviar bot en x minutos",
          expiresTicket: "Cerrar chats abiertos después de x minutos",
          expiresTicketNPS: "Cerrar chats esperando evaluación después de x minutos",
          maxUseBotQueuesNPS: "Cantidad máxima de veces que la evaluación va a ser enviada",
          closeLastMessageOptions1: "Del agente/Cliente",
          closeLastMessageOptions2: "Del agente",
          outOfHoursMessage: "Mensaje de fuera de horario de atención",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para política de privacidad",
          lgpdMessage: "Mensaje de bienvenida LGPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrado por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - La escala debe ser de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Cola",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage: "Tiempo en minutos para envío del aviso de inactividad",
          whenExpiresTicket: "Cerrar chats abiertos cuando la última mensaje sea",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Cola para importar los mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos"
        },
        messages: {
          clickSaveToRegister: "Haga clic en guardar para registrar cambios",
        },
        flowBuilder: {
          welcomeFlow: "Flujo de bienvenida",
          welcomeFlowDescription: "Este flujo se dispara solo para contactos nuevos, personas que no tienes en tu lista de contactos y que enviaron un mensaje",
          defaultResponseFlow: "Flujo de respuesta por defecto",
          defaultResponseFlowDescription: "La Respuesta por Defecto se envía con cualquier carácter diferente de una palabra clave. ¡ATENCI?N! Se disparará si la atención ya está cerrada y han pasado 6 horas desde su cierre.",
          title: "Flujo por defecto",
          save: "Guardar",
          updatedSuccess: "Flujos por defecto actualizados",
          deleteConfirmation: "¿Estás seguro de que deseas eliminar este flujo? Todas las integraciones relacionadas se perderán.",
        },
        success: "Conexión guardada con éxito.",
        errorSendQueue: "Se informó tiempo para redirigir cola, pero no se seleccionó fila para redirigir. Ambos campos deben estar llenos",
        errorExpiresNPS: "Es obligatorio informar un tiempo para evaluación cuando se utiliza el NPS.",
        errorRatingMessage: "Es obligatorio informar un mensaje de evaluación cuando se utiliza el NPS."
      },
      qrCode: {
        message: "Escanee el QR desde WhatsApp para vincular la sesion"
      },
      qrcodeModal: {
        waiting: "Generando QR..."
      },
      forbiddenPage: {
        accessDenied: "¡Ups! ¡Acceso Denegado!",
        buttons: {
          back: "Volver"
        }
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage: "¿Estás seguro de que deseas eliminar este contacto? Todos los atendimientos relacionados se perderán.",
          blockContact: "¿Estás seguro de que deseas bloquear este contacto?",
          unblockContact: "¿Estás seguro de que deseas desbloquear este contacto?",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport: "¿Desea importar todas las conversaciones del teléfono?"
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto"
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo electrónico",
          connection: "Conexión",
          actions: "Acciones",
          lastMessage: "?ltima Mensaje",
          status: "Estado",
          source: "Origen",
          followUp: "Seguimiento",
          tags: "Etiquetas",
          products: "Producto",
          payment: "Pago",
          attendant: "Agente",
          selectAll: "Seleccionar todos los contactos",
          selectContact: "Seleccionar contacto {{name}}",
        },
        productStatus: {
          pending: "Pendiente",
          completed: "Completado",
          cancelled: "Cancelado",
          refunded: "Reembolsado",
          in_progress: "En Progreso",
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar / Exportar del Excel",
          importExport: "Importar / Exportar"
        },
        bulkActions: {
          deleteSelected: "Eliminar Seleccionados ({{count}})",
          deleteConfirmTitle: "¿Estás seguro de que deseas eliminar {{count}} contactos seleccionados?",
          deleteConfirmMessage: "Esta acción es irreversible.",
          deleteSuccess: "¡Contactos seleccionados eliminados con éxito!",
          blockContact: "Contacto bloqueado",
          unblockContact: "Contacto desbloqueado",
          selectConnectionToImport: "Elige de qué conexión deseas importar"
        },
        tagsFilter: {
          title: "Filtrar por Etiquetas",
          placeholder: "Selecciona etiquetas...",
          noTags: "Sin etiquetas disponibles",
          clearFilters: "Limpiar filtros",
          selectedTags: "Etiquetas seleccionadas"
        },
        validation: {
          nameRequired: "El nombre es obligatorio",
          numberRequired: "El número es obligatorio",
          emailRequired: "El email es obligatorio",
          invalidEmail: "Email inválido",
          numberExists: "Este número ya existe",
          emailExists: "Este email ya existe",
          invalidNumber: "Número inválido",
          numberTooShort: "Número demasiado corto",
          numberTooLong: "Número demasiado largo",
          nameTooShort: "Nombre demasiado corto",
          nameTooLong: "Nombre demasiado largo"
        },
        filters: {
          showLabel: "Mostrar",
          showOnlyAgenda: "Solo mi agenda",
          showAll: "Todos los contactos",
          source: "Origen",
          sourceAll: "Todos",
          sourceManual: "Manual",
          sourceWhatsappRoster: "WhatsApp (agenda)",
          sourceExcelImport: "Excel/CSV",
          sourceAutoCreated: "Auto-creados",
          sourceChatImport: "Chats"
        },
        source: {
          manual: "Creado manualmente",
          whatsappRoster: "Importado de WhatsApp",
          excelImport: "Importado de Excel/CSV",
          autoCreated: "Auto-creado por mensaje",
          chatImport: "Importado de chats"
        },
      },
      tagsFilter: {
        placeholder: "Filtrar por Etiquetas",
      },
      contactImport: {
        title: "Importar contactos desde archivo",
        validation: {
          noNumberField: "No se seleccionó el campo de número de contacto",
          noNameField: "No se seleccionó el campo de nombre de contacto",
          noContactsSelected: "Ningún contacto seleccionado",
          fieldAlreadySelected: "El campo {{field}} ya fue seleccionado."
        },
        messages: {
          successComplete: "Importación realizada con éxito",
          successWithErrors: "Importación realizada con éxito, pero hubo algunos errores",
          importing: "Importando... Espere",
          processing: "Procesando archivo...",
          invalidFile: "¡Archivo inválido!",
          contactsCreated: "contactos creados",
          contactsIgnored: "contactos ignorados (número inválido o no marcados para actualizar)"
        },
        fields: {
          name: "Nombre",
          number: "Número",
          email: "E-mail",
          tags: "Etiquetas",
          followUp: "Seguimiento (Observaciones)",
          productName: "Producto (Nombre)",
          productStatus: "Producto (Estado)"
        },
        buttons: {
          downloadModel: "Descargar modelo",
          validateWhatsApp: "Validar contactos en WhatsApp",
          importContacts: "Importar contactos",
          cancel: "Cancelar",
          back: "Volver"
        },
        dropzone: {
          clickOrDrag: "Haga clic o arrastre un archivo",
          importantNote: "* Importante: Solo se aceptan archivos con extensiones: xls, xlsx, csv, txt"
        },
        sheetName: "Contactos",
        sampleContact: {
          name: "Juan",
          number: "5491112345678",
          email: "juan@email.com",
          tags: "cliente, vip",
          followUp: "",
          productName: "Curso Marketing",
          productStatus: "completado"
        },
        filters: {
          filter: "Filtrar",
          clearAll: "Limpiar filtros",
          noResults: "No se encontraron resultados"
        }
      },
      forwardMessage: {
        text: "Reenviada"
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar"
        }
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voiceKey: "Clave de la API de Voz",
          voiceRegion: "Región de Voz",
          model: "Modelo"
        },
        success: "¡Prompt guardado con éxito!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Obligatorio",
          promptDescription: "Describe el entrenamiento para Inteligencia Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informa el modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4096 tokens",
          informMaxTokens: "Informa el número máximo de tokens",
          minZero: "Mínimo 0",
          maxOne: "Máximo 1",
          informTemperature: "Informa la temperatura",
          informApiKey: "Informa la API Key",
          informQueue: "Informa la cola",
          minMessages: "Mínimo 1 mensaje",
          maxMessages: "Máximo 50 mensajes",
          informMaxMessages: "Informa el número máximo de mensajes",
          informVoiceMode: "Informa el modo de voz"
        },
        errors: {
          savePrompt: "Error al guardar el prompt"
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voices: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara"
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!"
        },
        buttons: {
          add: "Agregar Prompt"
        },
        errors: {
          noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        }
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto"
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo electrónico",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          chatBotContact: "Deshabilitar chatbot",
          followUp: "Seguimiento (Observaciones)",
          followUpPlaceholder: "Observaciones sobre el contacto...",
          termsLGDP: "Términos LGPD aceptados en:",
          whatsapp: "Conexión Origen: ",
          numberPlaceholder: "5513912344321",
          emailPlaceholder: "Dirección de correo electrónico",
          products: "Productos",
          productName: "Nombre del producto",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          addProduct: "Agregar",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Contacto guardado con éxito."
      },
      contactTagListModal: {
        title: "Contactos",
        table: {
          id: "ID",
          name: "Nombre",
          number: "Número",
          actions: "Acciones"
        }
      },
      flowbuilder: {
        title: "Flujos de conversación",
        subMenus: {
          campaign: "Flujo de Campaña",
          conversation: "Flujo de Conversación"
        },
        buttons: {
          add: "Agregar Flujo",
          editName: "Editar nombre",
          editFlow: "Editar flujo",
          duplicate: "Duplicar",
          delete: "Eliminar"
        },
        table: {
          status: "Estado"
        },
        status: {
          active: "Activo",
          inactive: "Inactivo"
        },
        toasts: {
          deleteSuccess: "Flujo eliminado con éxito",
          duplicateSuccess: "Flujo duplicado con éxito"
        },
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar este flujo? Se perderán todas las integraciones relacionadas.",
          duplicateTitle: "¿Quieres duplicar el flujo {flowName}?",
          duplicateMessage: "¿Estás seguro de que quieres duplicar este flujo?"
        }
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flujo predeterminado",
        title: {
          add: "Agregar Flujo",
          edit: "Editar Flujo"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "¡Ingresa un nombre!"
        }
      },
      queueModal: {
        title: {
          queueData: "Datos de la cola",
          text: "Horarios de atención",
          add: "Agregar cola",
          edit: "Editar cola",
          confirmationDelete: "¿Está seguro? Todas las opciones de integraciones serán eliminadas."
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la cola (Bot)",
          rotate: "Rotación",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje de fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Lista de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menú",
          message: "Mensaje de retorno",
          queue: "Cola para transferencia",
          integration: "Integración",
          file: "Archivo",
          selectFile: "Seleccione un archivo",
          timeOptions: {
            minutes2: "2 minutos",
            minutes5: "5 minutos",
            minutes10: "10 minutos",
            minutes15: "15 minutos",
            minutes30: "30 minutos",
            minutes45: "45 minutos",
            minutes60: "60 minutos",
          },
        },
        validations: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Requerido",
          mustHaveFriends: "Debe tener amigos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue opciones para construir un chatbot",
          toolTip: "Si hay solo una opción, se elegirá automáticamente, haciendo que el bot responda con el mensaje de la opción y siga adelante",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Cola",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle: "El mensaje es obligatorio para seguir al siguiente nivel",
          toolTipMessageContent: "El mensaje es obligatorio para seguir al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Cola",
          selectIntegration: "Seleccione una Integración",
          addOptions: "Agregar opciones",
          confirmationDelete: "¿Está seguro? Todas las opciones internas también serán eliminadas",
          messageLabel: "Mensaje:",
          toolTipMessage: "El mensaje es obligatorio para seguir al siguiente nivel",
          toolTipContent: "Si el mensaje no está definido, el bot no seguirá adelante",
        },
        serviceHours: {
          dayWeek: "Día de la semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo"
        },
        general: {
          none: "Ninguno",
          message: "Mensaje:",
        },
      },
      colorBoxModal: {
        title: "Elige un color",
        buttons: {
          cancel: "Cancelar",
          ok: "OK",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto"
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "Contenido Json",
          urlN8N: "URL",
          urlN8NWebhook: "URL del Webhook (del N8N)",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot"
        },
        languages: {
          "pt-BR": "Portugués",
          "en": "Inglés",
          "es": "Español",
        },
        instructions: {
          n8nTitle: "Cómo configurar la integración con N8N (paso a paso)",
          n8nStep1: "En tu N8N, crea un nuevo workflow y agrega un nodo \"Webhook\" como primer nodo (trigger).",
          n8nStep2: "En el nodo Webhook, configura el método como POST. N8N generará una URL como: https://tu-n8n.com/webhook/abc123",
          n8nStep3: "Copia esa URL del webhook y pégala en el campo \"URL del Webhook\" arriba.",
          n8nStep4: "Construye el resto de tu workflow en N8N (ej: conectar a una IA, consultar base de datos, enviar correo, etc).",
          n8nStep5: "Después de guardar aquí, ve a Conexiones (WhatsApp) o Colas y vincula esta integración. Cada mensaje recibido en esa conexión/cola se enviará automáticamente a N8N.",
          n8nDataTitle: "Datos que N8N recibirá:",
          n8nReplyTitle: "Cómo N8N responde al cliente:",
          n8nReplyOption1: "Opción 1 (más simple) - En el último nodo del workflow, usa \"Respond to Webhook\" y retorna:",
          n8nReplyOption2: "Opción 2 (más control) - Usa el nodo \"HTTP Request\" para llamar a la API directamente. Los datos apiToken y apiUrl ya vienen en el webhook:",
          n8nTip: "Consejo: El token de la API está en Conexiones > editar la conexión WhatsApp > campo Token. Pero con la Opción 1 de arriba, no necesitas preocuparte por eso - solo retorna el texto en \"reply\".",
          webhookTitle: "Cómo configurar el Webhook",
          webhookStep1: "Configura tu sistema externo para recibir solicitudes POST en el endpoint deseado.",
          webhookStep2: "Pega la URL del endpoint en el campo de arriba. Cada mensaje recibido se enviará como POST con los datos del contacto, ticket y mensaje.",
          webhookStep3: "Si el endpoint retorna { \"reply\": \"texto\" } en la respuesta, el sistema enviará automáticamente ese mensaje al cliente en WhatsApp.",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito."
        }
      },
      userModal: {
        warning: "¡Para hacer la importación de los mensajes es necesario leer el qrCode nuevamente !!!",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar imagen",
          removeImage: "Eliminar imagen"
        },
        form: {
          name: "Nombre",
          none: "Ninguna",
          email: "Correo electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          whatsapp: "Conexión Predeterminada",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Visualizar llamadas sin cola",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menú predeterminado",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversaciones de otras colas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver conversaciones de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel de Atendimientos",
          allowConnections: "Permitir acciones en las conexiones",
          canViewAllContacts: "Visualizar Todos los Contactos"
        },
        tabs: {
          general: "General",
          permissions: "Permisos"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen"
        },
        success: "Usuario guardado con éxito."
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa"
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
          status: "Activo"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Empresa guardada con éxito.",
        validations: {
          nameRequired: "El nombre es obligatorio",
          emailInvalid: "El email es inválido",
          emailRequired: "El email es obligatorio",
          passwordRequired: "La contraseña es obligatoria",
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
        },
      },
      scheduleModal: {
        title: {
          add: "Nueva Programación",
          edit: "Editar Programación"
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programación"
        },
        success: "Programación guardada con éxito.",
        validations: {
          tooShort: "Mensaje muy corto",
          required: "Obligatorio"
        },
        toasts: {
          deleted: "Media eliminada con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar Media",
          deleteMessage: "¿Estás seguro de que quieres eliminar esta media?"
        },
        status: {
          sending: "Enviando",
          pending: "Pendiente",
          sent: "Enviado",
          error: "Error de Envío"
        },
        recurrence: {
          title: "Recurrencia",
          description: "Puedes elegir enviar el mensaje de forma recurrente y elegir el intervalo. Si es un mensaje único, no cambies nada en esta sección.",
          interval: "Intervalo",
          intervalValue: "Valor del Intervalo",
          sendTimes: "Enviar cuántas veces",
          intervalTypes: {
            days: "Días",
            weeks: "Semanas",
            months: "Meses",
            minutes: "Minutos"
          },
          businessDays: {
            normal: "Enviar normalmente en días no laborables",
            before: "Enviar un día laborable antes",
            after: "Enviar un día laborable después"
          }
        },
        calendar: {
          messages: {
            date: "Fecha",
            time: "Hora",
            event: "Evento",
            allDay: "Todo el Día",
            week: "Semana",
            work_week: "Programaciones",
            day: "Día",
            month: "Mes",
            previous: "Anterior",
            next: "Siguiente",
            yesterday: "Ayer",
            tomorrow: "Mañana",
            today: "Hoy",
            agenda: "Agenda",
            noEventsInRange: "No hay programaciones en el período.",
            showMore: "más"
          }
        },
        permissions: {
          noAccess: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        }
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
          addKanban: "Nueva Columna",
          editKanban: "Editar Columna"
        },
        form: {
          name: "Nombre",
          color: "Color",
          aiAutoReplyEnabled: "Activar IA automatica para esta clasificacion",
          timeLane: "Tiempo en horas para redirigir a la columna",
          nextLaneId: "Columna",
          greetingMessageLane: "Mensaje de bienvenida de la columna",
          rollbackLaneId: "Volver a la Columna después de retomar el atendimiento"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        validation: {
          tooShort: "¡Demasiado corto!",
          required: "Obligatorio"
        },
        success: "Etiqueta guardada con éxito.",
        successKanban: "Columna guardada con éxito."
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos"
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo"
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción"
        },
        success: "¡Lista de archivos guardada con éxito!"
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para comenzar a conversar.",
        deleteConversationTitle: "Eliminar Conversación",
        deleteConversationMessage: "Esta acción no se puede revertir, ¿confirmar?",
        messagePlaceholder: "Escribe tu mensaje...",
        sendButtonTooltip: "Enviar mensaje",
        noMessagesYet: "Aún no hay mensajes. ¡Comienza la conversación!",
        loadingMessages: "Cargando mensajes...",
        popover: {
          buttonTooltip: "Conversaciones internas",
          loading: "Cargando conversaciones...",
          noChats: "No hay conversaciones disponibles",
          notificationNotSupported: "Este navegador no admite notificaciones",
          accessibilityLabel: "Lista de conversaciones internas",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO ABAJO",
          titleFileList: "Lista de archivo(s)"
        }
      },
      chatInternal: {
        new: "Nueva",
        tabs: {
          chats: "Chats",
          messages: "Mensajes",
        },
        form: {
          titleLabel: "Título",
          titlePlaceholder: "Título",
        },
        modal: {
          conversation: "Conversación",
          title: "Título",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar"
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede revertir, ¿confirmar?"
        }
      },
      ticketsManager: {
        questionCloseTicket: "¿DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "SÍ",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Colas"
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos"
        },
        toasts: {
          deleted: "El chat que estabas viendo fue eliminado."
        },
        notification: {
          message: "Mensaje de"
        },
        tabs: {
          open: {
            title: "Abiertas"
          },
          closed: {
            title: "Resueltos"
          },
          search: {
            title: "Búsqueda"
          }
        },
        search: {
          placeholder: "Buscar chat y mensajes",
          filterConections: "Filtrar por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente"
          },
          filterUsers: "Filtrar por Usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Tickets por página"
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a la Cola",
          scredule: "Programación",
          deleteTicket: "Eliminar Ticket",
          quickMessageFlash: "Respuestas rápidas"
        },
        noContactName: "(sin contacto)",
        noDepartment: "Sin departamento",
        group: "Grupo",
        transferTooltip: "Transferir Ticket",
        closedTicket: {
          closedMessage: "Cerrar Ticket Con Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket Sin Mensaje de Despedida"
        }
      },
      messages: {
        download: "Descargar",
        today: "HOY",
        contact: "Contacto",
        forwarded: "Reenviado",
        deletedByContact: "?? Este mensaje fue eliminado por el contacto &nbsp;",
        deletedMessage: "?? _Mensaje eliminado_ ",
        deletedBySender: "?? Este mensaje fue eliminado &nbsp;",
        youReacted: "Reaccionaste... ",
        sayHello: "¡Saluda a tu nuevo contacto!",
        dropFile: "Suelta el archivo aquí",
        facebookPolicy: "Tienes 24h para responder después de recibir un mensaje, según las políticas de Facebook.",
        defaultMetaMessage: "¡Hola! Estoy interesado y me gustaría más información, por favor.",
      },
      ticketsResponsive: {
        search: {
          searchInMessagesTooltip: "Marca para buscar también en el contenido de los mensajes (más lento)",
        },
        filter: {
          all: "Todos",
        },
        sort: {
          ascending: "Ascendente",
          descending: "Descendente",
        },
      },
      contactForm: {
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Obligatorio",
          invalidEmail: "Email inválido",
        },
        placeholders: {
          number: "5513912344321",
          email: "Dirección de correo",
        },
      },
      common: {
        image: "imagen",
      },
      messageInputResponsive: {
        privateMessage: {
          suffix: "Mensaje Privado",
        },
        type: {
          document: "Documento",
          buttons: "Botones",
        },
        tooltip: {
          toggleSignature: "Habilitar/Deshabilitar Firma",
          toggleComments: "Habilitar/Deshabilitar Comentarios",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Selecciona una cola",
        fieldWhatsapp: "Selecciona un whatsapp",
        noOptions: "Ningún usuario encontrado con ese nombre",
        msgTransfer: "Observaciones - mensaje interno, no va para el cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar"
        }
      },
      ticketsList: {
        called: "Llamado",
        today: "Hoy",
        missedCall: "Llamada de voz/video perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Atendiendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage: "Ningún chat encontrado con este estado o término buscado",
        noQueue: "Sin Cola",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opciones de Kanban",
          showAll: "Ver Todos",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar sector"
        }
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        selectQueue: "Seleccione una cola",
        selectConnection: "Seleccione una Conexión",
        queueError: "Seleccione una cola",
        close: "Cerrar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar"
        },
        form: {
          contact: "Contacto",
          queue: "Cola",
          message: "Mensaje inicial",
          contactPlaceholder: "Buscar contacto...",
          queuePlaceholder: "Seleccionar cola...",
          messagePlaceholder: "Mensaje inicial opcional...",
          connectionPlaceholder: "Seleccione una Conexión..."
        },
        validation: {
          contactRequired: "Debes seleccionar un contacto",
          queueRequired: "Debes seleccionar una cola"
        }
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar"
        }
      },
      mainDrawer: {
        sections: {
          management: "Gerencia"
        },
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel",
          tickets: "Chat",
          quickMessages: "Respuestas rápidas",
          contacts: "Contactos",
          queues: "Colas & Chatbot",
          flowbuilder: "Flowbuilder",
          tags: "Etiquetas",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuraciones",
          files: "Lista de archivos",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programaciones",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Prompts",
          allConnections: "Administrar conexiones",
          reports: "Informes",
          management: "Gerencia"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Salir",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y daré continuidad en tu atendimiento.",
            virtualAssistant: "Asistente Virtual",
            token: "Token inválido, por favor entra en contacto con el administrador de la plataforma."
          },
          message: {
            location: "Ubicación",
            contact: "Contacto"
          },
          notRegister: "Ningún registro",
          refresh: "Actualizar"
        }
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Portugués",
        es: "Español",
        en: "English",
        tr: "Türkçe"
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID del usuario/agente",
          queueId: "ID de la Cola"
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado"
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Media"
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1: "Antes de enviar mensajes, es necesario el registro del token vinculado a la conexión que enviará los mensajes. <br />Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el debido campo.",
            comments2: "El número para envío no debe tener máscara o caracteres especiales y debe ser compuesto por:",
            codeCountry: "Código del País",
            code: "DDD",
            number: "Número"
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions: "Siguen abajo la lista de informaciones necesarias para envío de los mensajes de texto:"
          },
          media: {
            title: "2. Mensajes de Media",
            instructions: "Siguen abajo la lista de informaciones necesarias para envío de los mensajes de texto:"
          }
        },
        messages: {
          noPermission: "Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
          success: "Mensaje enviado con éxito",
        },
        form: {
          send: "Enviar",
          testSend: "Prueba de Envío",
        },
        documentation: {
          endpoint: "Endpoint: ",
          method: "Método: ",
          post: "POST",
          headers: "Headers: ",
          headersTextAuth: "Authorization Bearer (token registrado) y Content-Type (application/json)",
          headersMediaAuth: "Authorization Bearer (token registrado) y Content-Type (multipart/form-data)",
          body: "Body: ",
          formData: "FormData: ",
          bodyExample: "{\n  \"number\": \"558599999999\",\n  \"body\": \"Message\",\n  \"userId\": \"ID usuario o \\\"\\\"\",\n  \"queueId\": \"ID Cola o \\\"\\\"\",\n  \"sendSignature\": \"Firmar mensaje - true/false\",\n  \"closeTicket\": \"Cerrar el ticket - true/false\"\n}",
          formDataFields: {
            number: "number: 558599999999",
            body: "body: Message",
            userId: "userId: ID usuario o \\\"\\\"",
            queueId: "queueId: ID de la cola o \\\"\\\"",
            medias: "medias: archivo",
            sendSignature: "sendSignature: Firmar mensaje true/false",
            closeTicket: "closeTicket: Cerrar ticket true/false",
          },
        },
      },
      notifications: {
        noTickets: "Ninguna notificación."
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin anexo",
        confirmationModal: {
          deleteTitle: "Exclusión",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea proseguir?"
        },
        buttons: {
          add: "Agregar",
          attach: "Anexar archivo",
          cancel: "Cancelar",
          edit: "Editar"
        },
        toasts: {
          success: "Respuesta rapida guardada con exito.",
          deleted: "Archivo o respuesta eliminada con exito."
        },
        dialog: {
          title: "Respuesta rapida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir edicion global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir vista a otros usuarios"
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del archivo",
          status: "Estado"
        }
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lista",
          downloadSample: "Descargar Plantilla de Ejemplo"
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          deleted: "Registro excluido"
        }
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar"
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar"
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Desea importar los contactos de esta planilla? ",
          importTitlte: "Importar"
        },
        toasts: {
          deleted: "Registro excluido"
        },
        downloadTemplate: "Haga clic aquí para descargar plantilla de ejemplo.",
        whatsappValid: "WhatsApp Válido",
        whatsappInvalid: "WhatsApp Inválido"
      },
      kanban: {
        title: "Kanban",
        subtitle: "Visualización de tickets en formato Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Panel",
          tags: "Lanes"
        },
        ticketNumber: "Ticket nº ",
        viewTicket: "Ver Ticket",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        search: "Buscar",
        addColumns: "+ Agregar columnas",
        ticketTagRemoved: "¡Etiqueta de Ticket Eliminada!",
        ticketTagAdded: "¡Etiqueta de Ticket Agregada con ?xito!",
        ticketMoveError: "Error al mover ticket",
        iconChannelError: "Error",
        noTickets: "Ningún ticket",
        emptyStateTags: "Ninguna etiqueta Kanban creada",
        emptyStateTagsDescription: "Crea tu primera etiqueta Kanban para comenzar a organizar tickets",
        createFirstTag: "Crear Primera Etiqueta",
        emptyStateTickets: "Ningún ticket encontrado",
        emptyStateTicketsDescription: "Ajusta los filtros de fecha o crea nuevos tickets",
        errorTitle: "Error al cargar Kanban",
        errorDescription: "Ocurrió un error al buscar datos. Inténtalo de nuevo.",
        retry: "Intentar Nuevamente",
      },
      campaigns: {
        status: {
          inactive: "Inactiva",
          scheduled: "Programada",
          inProgress: "En Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        common: {
          none: "Ninguna",
          notDefined: "No definida",
          noSchedule: "Sin programación",
          notCompleted: "No concluída",
          enabled: "Habilitada",
          disabled: "Deshabilitada",
        },
        modal: {
          tabLabels: {
            msg1: "Msg. 1",
            msg2: "Msg. 2",
            msg3: "Msg. 3",
            msg4: "Msg. 4",
            msg5: "Msg. 5",
          },
          helpText: "Utiliza variables como {nome}, {numero}, {email} o define variables personalizadas.",
        },
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listado",
          listContacts: "Lista de contactos",
          settings: "Configuraciones"
        },
        settings: {
          randomInterval: "Intervalo Aleatorio de Disparo",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo mayor",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido"
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
          stopCampaign: "Parar Campaña",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          option: "Ninguna",
          disabled: "Deshabilitada",
          enabled: "Habilitada",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Concluída",
          confirmation: "Confirmación",
          actions: "Acciones"
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Apenas Visualización",
          help: "Utiliza variables como {nome}, {numero}, {email} o define variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de Contacto",
            tagList: "Etiquetas",
            statusTicket: "Estado del Ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir ticket"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Cerrar",
            attach: "Anexar Archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido"
        },
        noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo.",
      },
      campaignReport: {
        title: "Informe de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregues",
        connection: "Conexión",
        contactLists: "Lista de Contactos",
        schedule: "Programación",
        conclusion: "Conclusión",
        noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo.",
        status: "Estado:",
        of: "de",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos"
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones"
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualización",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro excluido",
          noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        }
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        noPermissionMessage: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo.",
        settingsSaved: "Configuraciones guardadas",
        intervals: "Intervalos",
        seconds: "segundos",
      },
      campaignsPhrase: {
        title: "Campañas",
        phraseDeleted: "Frase eliminada",
        phraseUpdated: "¡Frase modificada con éxito!",
        phraseCreated: "¡Frase creada con éxito!",
        addCampaign: "Campaña",
        table: {
          name: "Nombre",
          status: "Estado",
          active: "Activo",
          inactive: "Desactivado",
          empty: "No se encontraron campañas por frase",
        },
        modal: {
          editTitle: "Editar campaña con flujo por frase",
          newTitle: "Nueva campaña con flujo por frase",
          nameLabel: "Nombre del disparo por frase",
          flowLabel: "Elige un flujo",
          flowPlaceholder: "Elige un flujo",
          connectionPlaceholder: "Selecciona una Conexión",
          phraseLabel: "¿Qué frase dispara el flujo?",
          matchTypeLabel: "Tipo de coincidencia",
          matchTypeExact: "Coincidencia Exacta",
          matchTypeContains: "Contiene la palabra",
          matchTypeTooltip: "Exacta: el mensaje debe ser igual a la palabra. Contiene: la palabra puede aparecer en cualquier parte del mensaje",
          statusLabel: "Estado",
          cancelButton: "Cancelar",
          saveButton: "Guardar campaña",
          createButton: "Crear campaña",
        },
      },
      queues: {
        title: "Colas & Chatbot",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          orderQueue: "Ordenación de la cola (bot)",
          actions: "Acciones",
          ID: "ID"
        },
        buttons: {
          add: "Agregar cola"
        },
        toasts: {
          success: "Cola guardada con éxito",
          deleted: "Cola eliminada con éxito",
          queueDeleted: "¡Cola eliminada con éxito!",
          botSaved: "Bot guardado con éxito",
          clickToSave: "Haga clic en guardar para registrar los cambios",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede revertir! Los tickets de esta cola seguirán existiendo, pero ya no tendrán ninguna cola asignada."
        }
      },
      queue: {
        queueData: "Datos"
      },
      queueSelect: {
        inputLabel: "Colas",
        inputLabelRO: "Colas de solo lectura",
        withoutQueue: "Sin cola",
        undefined: "Cola no encontrada",
        errors: {
          loadError: "QUEUESELETSINGLE >>>"
        }
      },
      reports: {
        title: "Informes de Atendimientos",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha Apertura",
          dateClose: "Fecha Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "?lt. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atendimiento"
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Evaluados"
        },
        searchPlaceholder: "Buscar..."
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "?ltima actualización",
          actions: "Acciones"
        },
        buttons: {
          add: "Agregar Proyecto"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir! y será eliminada de las colas y conexiones vinculadas"
        },
        toasts: {
          deleted: "¡Integración eliminada con éxito!",
        },
        messages: {
          noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          avatar: "Avatar",
          name: "Nombre",
          email: "Correo electrónico",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          actions: "Acciones",
          ID: "ID"
        },
        profile: {
          admin: "Admin",
          user: "Usuario",
        },
        status: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
        },
        upload: {
          avatar: "Subir Avatar",
        },
        buttons: {
          add: "Agregar usuario"
        },
        toasts: {
          deleted: "Usuario eliminado con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Los atendimientos abiertos de este usuario se moverán para la cola."
        }
      },
      compaies: {
        title: "Empresas",
        form: {
          documentLabel: "CPF/CNPJ (opcional)",
          documentPlaceholder: "000.000.000-00 o 00.000.000/0000-00",
          documentInvalid: "CPF/CNPJ inválido",
          documentDuplicate: "CPF/CNPJ ya registrado",
          documentNotProvided: "No informado",
          nameRequired: "Nombre es obligatorio",
          emailRequired: "Correo electrónico es obligatorio",
        },
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programación",
          createdAt: "Creada En",
          dueDate: "Vencimiento",
          lastLogin: "?lt. Login",
          actions: "Acciones",
          money: "?",
          yes: "Sí",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          folderSize: "Tamaño Carpeta",
          totalFiles: "Total Archivos",
          lastUpdate: "?ltima Actualización",
        },
        searchPlaceholder: "Buscar empresas...",
        searchLabel: "Campo de búsqueda de empresas",
        clearSearch: "Limpiar búsqueda",
        buttons: {
          add: "Agregar empresa"
        },
        toasts: {
          deleted: "Empresa eliminada con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos de la empresa se perderán. Los tickets abiertos de este usuario se moverán para la cola."
        },
        notifications: {
          noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programaciones",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "?",
          public: "Público"
        }
      },
      helps: {
        title: "Central de Ayuda",
        thumbnail: "Miniatura",
        videoPlayerTitle: "Reproductor de video de YouTube",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar"
        }
      },
      schedules: {
        title: "Programaciones",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar esta Programación?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Programación"
        },
        toasts: {
          deleted: "Programación eliminada con éxito."
        }
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar esta Tag?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          id: "ID",
          name: "Nombre",
          aiAutoReply: "IA automatica",
          aiEnabled: "Activa",
          aiDisabled: "Inactiva",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros de Etiquetas",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Tag"
        },
        toasts: {
          deleted: "Tag eliminado con éxito."
        }
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "En abierto",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar esta Lane?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lane",
          backToKanban: "Volver al Kanban"
        },
        toasts: {
          deleted: "Lane eliminada con éxito."
        }
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción"
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas fueron excluidas con éxito!"
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?"
        }
      },
      settings: {
        success: "Configuraciones guardadas con éxito.",
        currency: "Moneda",
        title: "Configuraciones",
        tabs: {
          options: "Opciones",
          schedules: "Horarios",
          companies: "Empresas",
          plans: "Planes",
          helps: "Ayuda",
          whitelabel: "Whitelabel",
          timezone: "Zona Horaria",
          smtp: "Email / SMTP"
        },
        smtp: {
          title: "Configuración de Email (SMTP)",
          subtitle: "Configure el servidor SMTP para el envío de correos de recuperación de contraseña y notificaciones.",
          preset: "Proveedor de Email",
          presetCustom: "Personalizado",
          host: "Servidor SMTP",
          port: "Puerto",
          user: "Usuario / Email",
          password: "Contraseña",
          from: "Email Remitente",
          fromHelper: "Si está vacío, se usará el email del usuario SMTP",
          secure: "Seguridad",
          save: "Guardar Configuración",
          testConnection: "Probar Conexión",
          sendTestTitle: "Enviar Email de Prueba",
          testEmailLabel: "Email de destino",
          sendTest: "Enviar Prueba",
          fillRequired: "Complete Host, Usuario y Contraseña.",
          fillTestEmail: "Complete el email de destino.",
          saveSuccess: "Configuración SMTP guardada con éxito!",
          saveError: "Error al guardar configuración SMTP.",
          testError: "Error al probar conexión SMTP.",
          sendTestError: "Error al enviar email de prueba."
        },
        settingsConfig: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado"
            }
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda"
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Company/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario de Trabajo",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket: "Enviar mensaje transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo del Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp: "Informar que no acepta llamadas en whatsapp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR Firma",
            sendGreetingMessageOneQueues: "Enviar saludo cuando haya solamente 1 fila",
            sendQueuePosition: "Enviar mensaje con la posición de la cola",
            sendFarewellWaitingTicket: "Enviar mensaje de despedida en el Aguardando",
            acceptAudioMessageContact: "¿Aceptar recibir audio de todos los contactos?",
            enableLGPD: "Habilitar tratamiento LGPD",
            requiredTag: "Tag obligatoria para cerrar ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir para otra cola",
            DirectTicketsToWallets: "Mover automáticamente cliente para cartera",
            showNotificationPending: "Mostrar notificación para tickets pendientes",
            autoTranslate: "Traducción Automática de Mensajes",
            translateApiKey: "API Key OpenAI (para traducción)",
            translateApiKeyHelper: "Clave de la API OpenAI para traducción automática. Si está vacío, usa la clave del primer Prompt configurado.",
            sendWelcomeMessage: "Mensaje de bienvenida al registrarse",
            welcomeMessageTemplate: "Modelo del mensaje de bienvenida",
            welcomeMessageHelper: "Use variables: {name}, {companyName}, {email}, {phone}, {trialDate}. Si está vacío, usa el modelo predeterminado.",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la cola",
            AcceptCallWhatsappMessage: "Mensaje para informar que no acepta llamadas",
            greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
            transferMessage: "Mensaje de transferencia - ${queue.name} = fila destino"
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de bienvenida(LGPD)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje apagada",
            alwaysConsent: "Siempre solicitar consentimiento",
            obfuscatePhoneUser: "Ofuscar número teléfono para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado"
          },
        },
        toasts: {
          schedulesSavedSuccess: "Horarios actualizados con éxito.",
          operationUpdatedSuccess: "Operación actualizada con éxito.",
          recordsLoadError: "No se pudo cargar la lista de registros",
          operationSuccess: "¡Operación realizada con éxito!",
          operationError: "No se pudo realizar la operación. Verifique si ya existe un registro con el mismo nombre o si todos los campos están completados correctamente",
          operationDeleteError: "No se pudo realizar la operación",
          imageUploadProgress: "La imagen está {{progress}}% subida...",
          imageUploadError: "Hubo un problema al subir la imagen.",
          companyOperationError: "No se pudo realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si todos los campos están completados correctamente",
          planOperationError: "No se pudo realizar la operación. Verifique si ya existe un plan con el mismo nombre o si todos los campos están completados correctamente",
          helpOperationError: "No se pudo realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si todos los campos están completados correctamente",
        },
        whitelabel: {
          primaryColorLight: "Color Primario Modo Claro",
          primaryColorDark: "Color Primario Modo Oscuro",
          systemName: "Nombre del Sistema",
          lightLogo: "Logo Claro",
          darkLogo: "Logo Oscuro",
          favicon: "Favicon",
        },
        chatBotType: {
          text: "Texto",
        },
        modals: {
          deleteTitle: "Eliminar Registro",
          deleteConfirmation: "¿Realmente desea eliminar este registro?",
        },
        managers: {
          common: {
            yes: "Sí",
            no: "No",
          },
          companies: {
            recurrence: "Recurrencia",
          },
          plans: {
            queues: "Colas",
            value: "Valor",
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            instagram: "Instagram",
            internalChat: "Chat Interno",
            externalAPI: "API Externa",
            kanban: "Kanban",
            talkAI: "Prompts",
            integrations: "Integraciones",
          },
          helps: {
            title: "Título",
            video: "Video",
          },
        },
        timezone: {
          companyTimezone: {
            title: "Zona Horaria de la Empresa",
            selectLabel: "Seleccionar zona horaria",
            customHelperText: "Zona horaria personalizada para esta empresa",
            inheritedHelperText: "Usando la zona horaria por defecto del sistema",
          },
          defaultTimezone: {
            title: "Zona Horaria Por Defecto del Sistema",
            selectLabel: "Seleccionar zona horaria por defecto",
            helperText: "Esta zona horaria se utilizará por defecto para todas las empresas que no tengan una zona horaria personalizada",
          },
          buttons: {
            save: "Guardar",
            useDefault: "Usar Por Defecto",
            saveDefault: "Guardar Por Defecto",
          },
          preview: {
            currentTime: "Hora Actual",
            defaultTime: "Hora Por Defecto",
          },
          status: {
            custom: "Personalizado",
            inherited: "Heredado",
          },
          errors: {
            fetchAvailableTimezones: "Error al cargar las zonas horarias disponibles",
            fetchCompanyTimezone: "Error al cargar la zona horaria de la empresa",
            updateDefaultTimezone: "Error al actualizar la zona horaria por defecto",
            updateCompanyTimezone: "Error al actualizar la zona horaria de la empresa",
          },
          success: {
            defaultTimezoneUpdated: "Zona horaria por defecto actualizada con éxito",
            companyTimezoneUpdated: "Zona horaria de la empresa actualizada con éxito",
            companyTimezoneReset: "Zona horaria de la empresa restablecida con éxito",
          },
        }
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído a:",
          dialogRatingTitle: "¿Desea dejar una evaluación de atendimiento para el cliente?",
          dialogClosingTitle: "¡Finalizando el atendimiento con el cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elige un menú de evaluación",
          notMessage: "Ningún mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Habilitar integración",
            disableIntegration: "Deshabilitar integración",
            logTicket: "Logs del Ticket",
            requiredTag: "Debes asignar una etiqueta antes de cerrar el ticket.",
            enableTranslate: "Activar traducción automática para este contacto",
            disableTranslate: "Desactivar traducción automática para este contacto",
            translateEnabled: "Traducción activada",
            translateDisabled: "Traducción desactivada",
          }
        }
      },
      messagesInput: {
        placeholderPrivateMessage: "Escribe un mensaje o aprieta / para respuestas rápidas",
        placeholderOpen: "Escribe un mensaje o aprieta / para respuestas rápidas",
        placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privado",
        translateTooltip: "Su mensaje será traducido a"
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
          blockContact: "Bloquear contacto",
          unblockContact: "Desbloquear contacto",
        },
        toasts: {
          contactBlocked: "Contacto bloqueado",
          contactUnblocked: "Contacto desbloqueado",
        },
        confirmationModal: {
          blockMessage: "¿Realmente quieres bloquear este contacto? Ya no recibirás mensajes de él.",
          unblockMessage: "¿Realmente quieres desbloquear este contacto? Podrás comenzar a recibir mensajes de él.",
        },
        extraInfo: "Otras informaciones"
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          email: "E-mail",
          user: "Agente",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nro. de ticket",
          queue: "Sector",
          connection: "Conexion"
        }
      },
      ticketOptionsMenu: {
        schedule: "Programación",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Finalizar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Ticket",
          textarea: "Observación",
          placeholder: "Inserta aquí la información que deseas registrar"
        },
        confirmationModal: {
          title: "Eliminar el ticket del contacto",
          titleFrom: "del contacto ",
          message: "¡Atención! Todas las mensajes relacionadas con el ticket se perderán."
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar"
        }
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar"
        }
      },
      messageInput: {
        selectLanguage: "Seleccione el idioma",
        tooltip: {
          signature: "Habilitar/Deshabilitar Firma",
          privateMessage: "Habilitar/Deshabilitar Mensaje Privada",
          meet: "Enviar link para videoconferencia",
          language: "Idioma del contacto: define a qu? idioma se traducir? el mensaje",
        },
        type: {
          imageVideo: "Fotos y vídeos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Vídeo llamada"
        }
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Conversar Con",
        react: "Reaccionar",
        saveToContact: "Guardar en contacto",
        confirmationModal: {
          title: "¿Apagar mensaje?",
          message: "Esta acción no se puede revertir."
        }
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Colas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción"
        }
      },
      userStatus: {
        online: "En línea",
        offline: "Fuera de línea",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "Ningún WhatsApp predeterminado encontrado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no fue inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor, intente nuevamente.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un tíquete abierto para este contacto.",
        ERR_TICKET_ALREADY_ACCEPTED: "Este ticket ya ha sido aceptado por otro agente.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuario fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "Ninguna configuración encontrada con este ID.",
        ERR_NO_CONTACT_FOUND: "Ningún contacto encontrado con este ID.",
        ERR_NO_TICKET_FOUND: "Ningún tíquete encontrado con este ID.",
        ERR_NO_USER_FOUND: "Ningún usuario encontrado con este ID.",
        ERR_NO_WAPP_FOUND: "Ningún WhatsApp encontrado con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear tíquete en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta color ya está en uso, elija otra.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de bienvenida es obligatorio cuando hay más de una cola.",
        ERR_OUT_OF_HOURS: "Acceso fuera del horario permitido para este usuario.",
        ERR_CONTACT_MAX_TAGS: "Cada contacto puede tener maximo 3 clasificaciones.",
        ERR_USER_EMAIL_ALREADY_EXISTS: "Este email ya está en uso. Utilice otro email.",
        ERR_COMPANY_INVALID_NAME: "El nombre de la organización debe tener al menos 2 caracteres.",
        ERR_COMPANY_DUPLICATE_FIELD: "Ya existe un registro con estos datos.",
        ERR_COMPANY_CREATION_FAILED: "Error al crear la empresa. Inténtelo de nuevo.",
        ERR_GENERIC_ERROR: "¡Ocurrió un error!",
      },
      flowBuilderConfig: {
        title: "Diseña tu flujo",
        actions: {
          import: "Importar",
          export: "Exportar",
          save: "Guardar"
        },
        messages: {
          flowStart: "Inicio del flujo",
          interval: "Intervalo {{seconds}} seg.",
          intervalFormatted: "Intervalo {{value}} {{unit}}",
          businessHoursLabel: "Hor. Laboral",
          units: {
            seconds: "seg.",
            minutes: "min.",
            hours: "h",
            days: "días",
          },
          rememberSave: "¡No olvides guardar tu flujo!",
          flowSaved: "Flujo guardado con éxito"
        },
        nodes: {
          start: "Inicio",
          content: "Contenido",
          menu: "Menú",
          optionFormat: "[{{number}}] {{value}}",
          randomizer: "Aleatorizador",
          interval: "Intervalo",
          ticket: "Ticket",
          typebot: "TypeBot",
          openai: "OpenAI",
          question: "Pregunta",
          image: "Imagen",
          video: "Vídeo",
          audioNode: {
            title: "Audio",
            recordedLive: "Grabado en vivo",
            audioSent: "Audio enviado",
            browserNotSupported: "su navegador no soporta HTML5"
          },
          kanbanPhase: "Fase Kanban",
          addTag: "Agregar Etiqueta",
          noTag: "Sin etiqueta",
          noResponse: "Sin respuesta",
        },
        nodeDescriptions: {
          startFlow: "¡Este bloque marca el inicio de tu flujo!"
        },
        edges: {
          edgeWithoutOnDelete: "Edge sin onDelete configurado:",
          errorDeletingEdge: "Error al eliminar edge:",
          removeEdgeTooltip: "Eliminar conexión"
        },
        units: {
          seconds: "segundos"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          enterName: "¡Ingresa un nombre!",
          enterMessage: "¡Ingresa un mensaje!",
          required: "Obligatorio",
          describeAiTraining: "Describe el entrenamiento para Inteligencia Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informa el modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4096 tokens",
          informMaxTokens: "Informa el número máximo de tokens",
          minZero: "Mínimo 0",
          maxOne: "Máximo 1",
          informTemperature: "Informa la temperatura",
          informApiKey: "Informa la API Key",
          minOneMessage: "Mínimo 1 mensaje",
          maxFiftyMessages: "Máximo 50 mensajes",
          informMaxMessages: "Informa el número máximo de mensajes",
          informVoiceMode: "Informa el modo para Voz"
        },
        buttons: {
          add: "Agregar",
          save: "Guardar",
          edit: "Editar"
        },
        modals: {
          condition: {
            addTitle: "Agregar condición al flujo",
            editTitle: "Editar condición",
            fieldLabel: "Campo de la condición (Digite solo 1 clave)",
            validationRule: "Regla de validación",
            conditionValue: "Valor de la condición a ser analizada"
          },
          ticket: {
            addQueueError: "Agrega una cola",
            addTitle: "Agregar una cola al flujo",
            editTitle: "Editar cola",
            selectConnection: "Selecciona una Conexión"
          },
          randomizer: {
            addIntervalError: "Agrega el valor de intervalo",
            maxTimeError: "Máximo de tiempo alcanzado 120 segundos",
            addTitle: "Agregar un aleatorizador al flujo",
            editTitle: "Editar aleatorizador"
          },
          openai: {
            addTitle: "Agregar OpenAI/Gemini al flujo",
            editTitle: "Editar OpenAI/Gemini del flujo"
          },
          question: {
            addTitle: "Agregar Pregunta al flujo",
            editTitle: "Editar Pregunta",
            createTitle: "Crear Pregunta en el flujo",
            messageLabel: "Mensaje",
            saveAnswer: "Guardar respuesta"
          }
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voice: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara"
        }
      },
      flowBuilderModals: {
        textModal: {
          titleAdd: "Agregar mensaje al flujo",
          titleEdit: "Editar mensaje del flujo",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          fields: {
            message: "Mensaje"
          },
          validation: {
            tooShort: "¡Muy corto!",
            tooLong: "¡Muy largo!",
            required: "¡Ingresa un nombre!",
            messageRequired: "¡Ingresa un mensaje!"
          }
        },
        intervalModal: {
          titleAdd: "Agregar un intervalo al flujo",
          titleEdit: "Editar intervalo",
          buttonAdd: "Agregar",
          buttonEdit: "Editar",
          fields: {
            timeInSeconds: "Tiempo en segundos",
            timeValue: "Tiempo",
            unit: "Unidad",
            unitSeconds: "Segundos",
            unitMinutes: "Minutos",
            unitHours: "Horas",
            unitDays: "Días",
            businessHours: "Horario laboral",
            businessHoursHelp: "El mensaje se enviará solo durante el horario laboral configurado",
            startTime: "Inicio",
            endTime: "Fin",
            daysOfWeek: "Días de la semana",
            daySun: "Dom",
            dayMon: "Lun",
            dayTue: "Mar",
            dayWed: "Mié",
            dayThu: "Jue",
            dayFri: "Vie",
            daySat: "Sáb",
          },
          validation: {
            addValue: "Agrega el valor del intervalo",
            maxTime: "Valor máximo alcanzado para esta unidad",
            maxSeconds: "Máximo de 120 segundos",
            maxMinutes: "Máximo de 120 minutos",
            maxHours: "Máximo de 72 horas",
            maxDays: "Máximo de 30 días",
          }
        },
        typebotModal: {
          titleAdd: "Agregar Typebot al flujo",
          titleEdit: "Editar Typebot",
          buttonAdd: "Agregar",
          buttonEdit: "Guardar",
          fields: {
            url: "URL del Typebot",
            slug: "Slug del Bot (identificador)",
            expires: "Expiración de sesión (minutos)",
            delay: "Intervalo entre mensajes (ms)",
            keywordFinish: "Palabra para finalizar",
            keywordRestart: "Palabra para reiniciar",
            unknownMessage: "Mensaje de opción inválida",
            restartMessage: "Mensaje al reiniciar",
          },
          instructions: {
            title: "Cómo configurar Typebot (paso a paso)",
            step1: "Ten una instancia de Typebot corriendo (self-hosted o Typebot Cloud en typebot.io). Anota la URL base, ej: https://typebot.tuempresa.com",
            step2: "En el panel de Typebot, crea o abre el bot que deseas usar. El Slug es el identificador del bot en la URL, por ejemplo: si la URL del bot es typebot.io/mi-bot, el slug es \"mi-bot\".",
            step3: "En el campo \"URL del Typebot\" arriba, pega la URL base de tu instancia (sin barra al final). En el campo \"Slug\", pega el identificador del bot.",
            step4: "Configura la expiración de sesión (en minutos). Después de ese tiempo sin interacción, se iniciará una nueva conversación. Valor 0 = nunca expira.",
            step5: "Opcionalmente, define palabras clave para finalizar (ej: \"salir\") o reiniciar (ej: \"reiniciar\") la conversación con el bot.",
            variablesTitle: "Variables disponibles en Typebot:",
            varNumber: "Número del contacto en WhatsApp",
            varPushName: "Nombre del contacto en WhatsApp",
            varRemoteJid: "ID completo del contacto (JID)",
            jsonTitle: "Comandos avanzados (JSON):",
            jsonDesc: "En Typebot, envía un mensaje comenzando con # para ejecutar acciones en SOLUWHATS:",
            jsonStop: "Detiene el bot y transfiere a un agente",
            jsonQueue: "Transfiere a la cola ID 1",
            jsonUser: "Transfiere a cola 1, agente 5",
            tip: "Consejo: Typebot soporta textos, imágenes, audios, videos y botones de selección. Todos se envían automáticamente por WhatsApp.",
          },
        },
        menuModal: {
          titleAdd: "Agregar menú al flujo",
          titleEdit: "Editar menú",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          fields: {
            explanationMessage: "Mensaje de explicación del menú",
            addOption: "Agregar Opción",
            typeOption: "Escriba {{number}}",
            optionPlaceholder: "Escriba opción"
          },
          invalidOption: {
            title: "Opción inválida",
            messageLabel: "Mensaje para opción inválida",
            placeholder: "Ej: Opción inválida. Por favor, elija una de las opciones a continuación:",
            helperText: "Si se completa, cuando el cliente envíe algo fuera de las opciones, este mensaje será enviado y el menú se mostrará nuevamente."
          },
          timeout: {
            title: "Timeout (sin respuesta)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, el flujo sigue por el camino de timeout (salida naranja)"
          }
        },
        singleBlockModal: {
          titleAdd: "Agregar contenido al flujo",
          titleEdit: "Editar contenido",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          elements: {
            text: "Texto",
            interval: "Intervalo",
            image: "Imagen",
            audio: "Audio",
            video: "Video",
            document: "Documento"
          },
          fields: {
            message: "Mensaje",
            timeInSeconds: "Tiempo en segundos",
            sendAsRecordedAudio: "Enviar como audio grabado en el momento",
            noFileSelected: "Ningún archivo seleccionado"
          },
          buttons: {
            sendImage: "Enviar imagen",
            sendAudio: "Enviar audio",
            sendVideo: "Enviar video",
            sendDocument: "Enviar Documento"
          },
          validation: {
            emptyMessageFields: "¡Campos de mensaje vacíos!",
            intervalValidation: "¡El intervalo no puede ser 0 o mayor que 120!",
            fileTooLarge2MB: "¡Archivo muy grande! Máximo 2MB",
            fileTooLarge5MB: "¡Archivo muy grande! Máximo 5MB",
            fileTooLarge20MB: "¡Archivo muy grande! Máximo 20MB",
            fileTooLarge15MB: "¡Archivo muy grande! Máximo 15MB",
            deleteEmptyCards: "Elimina las tarjetas vacías o envía los archivos pendientes.",
            browserNotSupported: "su navegador no soporta HTML5",
            onlyMp4Videos: "¡ATENCI?N! ¡Solo videos en MP4!"
          },
          messages: {
            contentAddedSuccess: "¡Contenido agregado con éxito!",
            uploadingFiles: "Subiendo archivos y creando contenido...",
            variables: "Variables"
          }
        },
        randomizerModal: {
          titleAdd: "Agregar un aleatorizador al flujo",
          titleEdit: "Editar aleatorizador",
          buttonAdd: "Agregar",
          buttonEdit: "Editar"
        },
        ticketModal: {
          titleAdd: "Agregar una cola al flujo",
          titleEdit: "Editar cola",
          buttonAdd: "Agregar",
          buttonEdit: "Editar",
          fields: {
            selectConnection: "Seleccione una Conexión"
          },
          validation: {
            addQueue: "Agrega una cola"
          }
        },
        openaiModal: {
          titleAdd: "Agregar OpenAI/Gemini al flujo",
          titleEdit: "Editar OpenAI/Gemini del flujo",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          models: {
            "gpt-4.1": "GPT 4.1",
            "gpt-4.1-mini": "GPT 4.1 Mini",
            "gpt-4.1-nano": "GPT 4.1 Nano",
            "gpt-4o": "GPT 4o",
            "gpt-4o-mini": "GPT 4o Mini",
            "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
            "gemini-2.5-pro": "Gemini 2.5 Pro",
            "gemini-2.5-flash": "Gemini 2.5 Flash",
            "gemini-2.0-flash": "Gemini 2.0 Flash",
            "gemini-2.0-pro": "Gemini 2.0 Pro",
          },
          voices: {
            text: "Texto",
            francisca: "Francisca",
            antonio: "Antonio",
            brenda: "Brenda",
            donato: "Donato",
            elza: "Elza",
            fabio: "Fabio",
            giovanna: "Giovanna",
            humberto: "Humberto",
            julio: "Julio",
            leila: "Leila",
            leticia: "Leticia",
            manuela: "Manuela",
            nicolau: "Nicolau",
            valerio: "Valerio",
            yara: "Yara"
          },
          validation: {
            tooShort: "¡Muy corto!",
            tooLong: "¡Muy largo!",
            required: "Obligatorio",
            promptRequired: "Describe el entrenamiento para Inteligencia Artificial",
            invalidModel: "Modelo inválido",
            minTokens: "Mínimo 10 tokens",
            maxTokens: "Máximo 4096 tokens",
            tokensRequired: "Informa el número máximo de tokens",
            temperatureRequired: "Informa la temperatura",
            temperatureMin: "Mínimo 0",
            temperatureMax: "Máximo 1",
            apiKeyRequired: "Informa la API Key",
            messagesMin: "Mínimo 1 mensaje",
            messagesMax: "Máximo 50 mensajes",
            messagesRequired: "Informa el número máximo de mensajes",
            voiceRequired: "Informa el modo para Voz"
          },
          instructions: {
            title: "Cómo configurar OpenAI (paso a paso)",
            step1: "Accede a platform.openai.com y crea una cuenta. En el menú lateral, ve a \"API Keys\" y haz clic en \"Create new secret key\". Copia la clave generada.",
            step2: "Pega la clave en el campo \"API Key\" arriba. Esta clave es secreta: no la compartas con nadie.",
            step3: "En el campo \"Prompt\", escribe las instrucciones de comportamiento de la IA. Ejemplo: \"Eres un asistente virtual de la empresa X. Responde de forma educada y objetiva sobre nuestros productos y servicios.\"",
            step4: "Elige el modelo: GPT-4o Mini es la mejor relación calidad-precio para atención al cliente. GPT-4.1 es más inteligente pero más caro. GPT-3.5 Turbo es el más barato.",
            step5: "La temperatura controla la creatividad (0 = respuestas exactas, 1 = respuestas creativas). Para atención al cliente, usa entre 0.3 y 0.7. Max Tokens limita el tamaño de la respuesta.",
            promptTipTitle: "Consejos para un buen prompt:",
            promptTip: "Sé específico sobre el rol de la IA, el tono de voz, los productos/servicios de la empresa y lo que NO debe hacer. Cuanto más detallado el prompt, mejores las respuestas.",
            tip: "Consejo: El campo \"Máx. Mensajes\" define cuántos mensajes de contexto recuerda la IA. Valores mayores = respuestas más contextuales pero cuestan más tokens.",
          },
        },
        geminiModal: {
          instructions: {
            title: "Cómo configurar Gemini IA (paso a paso)",
            step1: "Accede a aistudio.google.com e inicia sesión con tu cuenta de Google. Haz clic en \"Get API Key\" y luego \"Create API key\". Copia la clave generada.",
            step2: "Pega la clave en el campo \"API Key (Google AI)\" arriba. Esta clave es secreta: no la compartas con nadie.",
            step3: "En el campo \"Prompt\", escribe las instrucciones de comportamiento de la IA. Ejemplo: \"Eres un asistente virtual de la empresa X. Responde de forma educada y objetiva.\"",
            step4: "Elige el modelo: Gemini 2.5 Flash es la mejor relación calidad-precio. Gemini 2.5 Pro es más inteligente pero más lento. Gemini 2.0 Flash es el más rápido.",
            step5: "La temperatura controla la creatividad (0 = respuestas exactas, 1 = respuestas creativas). Para atención al cliente, usa entre 0.3 y 0.7.",
            promptTipTitle: "Consejos para un buen prompt:",
            promptTip: "Sé específico sobre el rol de la IA, el tono de voz, los productos/servicios y lo que NO debe hacer. Cuanto más detallado, mejores las respuestas.",
            tip: "Consejo: Gemini de Google tiene un plan gratuito generoso. Ideal para empezar a probar sin costos.",
          },
        },
        questionModal: {
          titleAdd: "Agregar Pregunta al flujo",
          titleEdit: "Editar Pregunta del flujo",
          titleCreate: "Crear Pregunta en el flujo",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          fields: {
            message: "Mensaje",
            saveAnswer: "Guardar respuesta"
          }
        }
      },
      moments: {
        title: "Panel de Atenciones",
        pending: "Pendientes",
        attendances: "Atenciones: ",
        noQueue: "SIN COLA",
        accessTicket: "Acceder Ticket"
      },
      flowBuilderNodes: {
        message: "Mensaje",
        condition: "Condición",
        image: "Imagen"
      },
      subscription: {
        title: "Suscripción",
        form: {
          licenseLabel: "Período de Licencia",
          licenseExpiresIn: "Su licencia expira en {{days}} días!",
          licenseExpiresToday: "Su licencia expira hoy!",
          billingEmailLabel: "Email de facturación",
          subscribeButton: "¡Suscribirse Ahora!"
        },
        checkout: {
          form: {
            fullName: "Nombre completo*",
            fullNameRequired: "El nombre completo es obligatorio",
            lastName: "Apellido*",
            lastNameRequired: "El apellido es obligatorio",
            address: "Dirección*",
            addressRequired: "La dirección es obligatoria",
            city: "Ciudad*",
            cityRequired: "La ciudad es obligatoria",
            state: "Estado*",
            stateRequired: "El estado es obligatorio",
            document: "RUC/DNI*",
            documentRequired: "RUC/DNI es obligatorio",
            documentInvalid: "Formato de RUC/DNI inválido",
            country: "País*",
            countryRequired: "El país es obligatorio",
            useAddressForPayment: "Usar esta dirección para detalles de pago",
            nameOnCard: "Nombre en la tarjeta*",
            nameOnCardRequired: "El nombre en la tarjeta es obligatorio",
            cardNumber: "Número de tarjeta*",
            cardNumberRequired: "El número de tarjeta es obligatorio",
            cardNumberInvalid: "El número de tarjeta no es válido (ej. 4111111111111)",
            expiryDate: "Fecha de expiración*",
            expiryDateRequired: "La fecha de expiración es obligatoria",
            expiryDateInvalid: "La fecha de expiración no es válida",
            cvv: "CVV*",
            cvvRequired: "CVV es obligatorio",
            cvvInvalid: "CVV es inválido (ej. 357)"
          }
        }
      },
      ticketsResponsive: {
        actions: {
          selectTicket: "Seleccionar Ticket",
          transferTicket: "Transferir Ticket",
          spyConversation: "Espiar Conversación"
        },
        tabs: {
          ticket: "Ticket",
          assistance: "Atenciones"
        },
        search: {
          searchInMessagesTooltip: "Marcar para buscar también en contenidos de mensajes (más lento)"
        },
        filter: {
          all: "Todos",
          unreplied: "Sin responder"
        },
        sort: {
          ascending: "Ascendente",
          descending: "Descendente"
        },
        dialog: {
          spyingConversation: "Espiando conversación",
          loadingMessages: "Cargando mensajes..."
        },
        status: {
          noQueue: "SIN COLA"
        }
      },
      messagesResponsive: {
        types: {
          location: "Ubicación",
          contact: "Contacto"
        },
        actions: {
          download: "Descargar",
          dropFileHere: "Suelta el archivo aquí"
        },
        status: {
          forwarded: "Reenviada",
          deletedByContact: "?? Este mensaje fue eliminado por el contacto",
          deletedMessage: "?? _Mensaje eliminado_",
          deletedByMe: "?? Este mensaje fue eliminado",
          edited: "Editada"
        },
        reactions: {
          youReacted: "Reaccionaste...",
          contactReacted: " reaccionó... "
        },
        timestamp: {
          today: "HOY"
        },
        placeholder: {
          sayHello: "¡Saluda a tu nuevo contacto!"
        },
        ads: {
          adClick: "Clic de Anuncio",
          defaultUserMessage: "¡Hola! Tengo interés y quisiera más información, por favor."
        },
        warnings: {
          facebookPolicy: "Tienes 24 horas para responder después de recibir un mensaje, según las políticas de Facebook."
        },
        translation: {
          translatedFrom: "Traducido de",
          showOriginal: "Ver original",
          showTranslation: "Ver traducción",
          autoTranslated: "Mensaje traducido automáticamente enviado",
        },
        transcription: {
          transcribe: "Transcribir audio",
          transcribing: "Transcribiendo...",
          showOriginal: "Ver original",
          showTranslation: "Ver traducción",
          language: "Idioma",
        }
      },
      messageInputResponsive: {
        type: {
          document: "Documento",
          buttons: "Botones"
        },
        tooltip: {
          toggleSignature: "Habilitar/Deshabilitar Firma",
          toggleComments: "Habilitar/Deshabilitar Comentarios"
        },
        privateMessage: {
          suffix: "Mensaje Privado"
        }
      },
      tagsResponsive: {
        validation: {
          tooShort: "¡Etiqueta muy corta!",
          maxThree: "Cada contacto puede tener maximo 3 clasificaciones."
        },
        placeholder: "Etiquetas"
      },
      showTicketOpenModal: {
        buttons: {
          close: "Cerrar"
        }
      },
      reactions: {
        successMessage: "Reacción enviada con éxito"
      },
      vcardPreview: {
        chatButton: "Chatear"
      },
      locationPreview: {
        viewButton: "Ver"
      },
      contactNotes: {
        addedSuccess: "¡Nota agregada con éxito!",
        deletedSuccess: "¡Nota eliminada con éxito!",
        deleteTitle: "Eliminar Registro",
        deleteConfirmation: "¿Realmente desea eliminar este registro?",
        cancelButton: "Cancelar",
        saveButton: "Guardar"
      },
      validationResponsive: {
        ratingRequired: "Calificación requerida"
      }
    }
  }
};

export { messages };
